import templateUrl from "emun.order/modify-order/order-changes-prompt.htm";
import OrderChangesPromptController from "emun.order/modify-order/order-changes-prompt.controller";
import open from "webmodals/open";

let OrderChangesPrompt = options => {
	let modalInstance = open({
		size: options.size || "lg",
		templateUrl: options.templateUrl || templateUrl,
		controller: OrderChangesPromptController,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => options
		}
	});

	return modalInstance.result;
};

export default OrderChangesPrompt;
